import { CaretLeft } from '@phosphor-icons/react';
import { cn } from '@/lib/utils';

interface BackButtonProps {
  onClick: () => void;
  label?: string;
  className?: string;
}

/**
 * The gap below the button belongs to the BUTTON, not to each page.
 *
 * Six of the ten call sites passed no margin at all and relied on whatever sat beneath —
 * usually the small uppercase category line above the title. With that line removed the title
 * ran straight into the button on Activities, Bank accounts, Settings and the solicitor pages.
 * Carrying the spacing here makes every back button sit the same distance from its title, and
 * `cn` (tailwind-merge) means a page that genuinely needs a different gap can still pass one.
 */
export function BackButton({
  onClick,
  label = 'Back',
  className,
}: BackButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'mb-4 inline-flex items-center gap-1.5 rounded-md border border-border bg-card px-2.5 py-1.5 text-sm font-medium text-muted-foreground shadow-sm transition-colors hover:border-brand-300 hover:bg-muted hover:text-foreground',
        className,
      )}
    >
      <CaretLeft className="h-4 w-4" />
      {label}
    </button>
  );
}
